/* (c) Dalineage, s.r.o. 2020-2025, all rights reserved */
package com.dalineage.client.batchtree

import scala.collection.immutable._

import com.dalineage.client
import client.adt.PropertyPanelADT

import com.dalineage.common
import common.adt.ExplorerDataADT

import scala.util.chaining._

object BatchTreeContextMenu {
  val unixTimestemp2String: Option[Long] => String = (timestamp) =>
    timestamp
      .map(java.util.Date(_))
      .map(_.toString())
      .getOrElse(" - ")

  def menu( node: ExplorerDataADT.ExplorerNode ): List[PropertyPanelADT.Property] = {
    node match
      case dir: ExplorerDataADT.ExplorerDir =>
        val text = "Use arrow keys or mouse to navigate the batch list"
        PropertyPanelADT.HelpText(text) ::
          PropertyPanelADT.KeyValue("Object type", "Directory", None) ::
          PropertyPanelADT.KeyValue("Object name", dir.name, None) ::
          PropertyPanelADT.Button("Create permanent link", 13, "batch-tree", true)
            .pipe(b => s"Press <b>Ctrl + Enter</b> to ${client.PropertyPanel.button(b)} to this directory")
            .pipe(PropertyPanelADT.HelpText(_)) :: Nil

      case batch: ExplorerDataADT.ProcessedBatch =>
        val output = batch.info.output
        val batchProperties = ("user", batch.info.user) ::
          ("Uploaded", unixTimestemp2String(batch.info.uploaded)) ::
          ("Gojs diagram", output.generateGoJsOutput.toString) ::
          ("Object browser", output.generateObjectBrowserOutput.toString) ::
          ("Name", batch.info.name) ::
          ("Id", batch.info.id) ::
          ("Description", batch.info.description) ::
          ("Source codes", batch.info.batchProcessingStats.get.totalFiles.toString) ::
          ("Syntax parsing errors",
            batch.info.batchProcessingStats.get.parserErrors.toString) ::
          ("Lineage analyzer failures",
            batch.info.batchProcessingStats.get.analyzerErrors.toString) ::
          ("Columns found", batch.info.batchProcessingStats.get.columnCount.toString) ::
          ("Relations found", batch.info.batchProcessingStats.get.relationCount.toString) ::
          Nil

        batchProperties.map{ case (k, v) =>
          PropertyPanelADT.KeyValue(k, v.toString, None)
        } ++ {
          PropertyPanelADT.Button("Download original input", 68, "batch-tree")
            .pipe(b => s"Press <b>d</b> to ${client.PropertyPanel.button(b)}")
            .pipe(PropertyPanelADT.HelpText(_))
            .pipe{ downloadButton =>
              PropertyPanelADT.Button("Delete batch", 46, "batch-tree")
                .pipe(b => s"Press <b>Delete</b> key to ${client.PropertyPanel.button(b)}")
                .pipe(PropertyPanelADT.HelpText(_))
                .pipe { deleteButton =>
                  PropertyPanelADT.Button("Open", 13, "batch-tree")
                    .pipe(b => s"Press <b>Enter</b> to ${client.PropertyPanel.button(b)} batch")
                    .pipe(PropertyPanelADT.HelpText(_))
                    .pipe(_ :: downloadButton :: deleteButton :: Nil)
                }
            }
        }
  }
}
